import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { registerLicense } from '@syncfusion/ej2-base';

registerLicense(
  'Ngo9BigBOggjHTQxAR8/V1JFaF1cX2hIf0x1RXxbf1x1ZFREalxVTnZWUiweQnxTdEBiWXxfcHRVQmFYWUV+XkleYg=='
);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    setTimeout(function () {
      navigator.serviceWorker.register('ngsw-worker.js');
    }, 1000);
  })
  .catch((err) => {});
